module.exports = __webpack_public_path__ + "img/close-modal.abf9a367.svg";